export default __webpack_public_path__ + "static/media/banner-unlimited.2c68a827.jpg";